import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'jalali-moment';

@Pipe({
  name: 'persianDate'
})
export class PersianDatePipe implements PipeTransform {

  transform(value: any, args?: any): unknown {
    return moment.unix(value / 1000).locale('fa').format('YYYY/MM/DD');
    // return null;
  }

}
